import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ISourceTreeView, ISourceTreeViewItem } from '@libs/portal-common/services';

@Component({
  selector: 'app-issue-mapping-field-selector',
  templateUrl: './issue-mapping-field-selector.component.html',
  styleUrls: ['./issue-mapping-field-selector.component.scss']
})
export class IssueMappingFieldSelectorComponent {
  @Input() sources: ISourceTreeView[] = [];
  @Input() selectedValues: ISourceTreeViewItem[] = [];
  @Input() activeVendorNames: Set<string> = new Set<string>();

  @Output() valueChange = new EventEmitter<ISourceTreeViewItem[]>();

  filterText = '';
  expandedGroups: { [key: string]: boolean } = {};

  toggleGroup(groupKey: string) {
    this.expandedGroups[groupKey] = !this.expandedGroups[groupKey];
  }

  addAllFromGroup(event: MouseEvent, group: any) {
    event.stopPropagation();
    const newItems = group.children.filter(child => !this.isMapped(child));

    if (newItems.length > 0) {
      const updatedSelection = [...this.selectedValues, ...newItems];
      this.valueChange.emit(updatedSelection);
    }
  }

  isMapped(item: any): boolean {
    return this.selectedValues.some(v => v.Key === item.Key);
  }

  addMapping(item: any) {
    if (!item.id || this.isMapped(item)) { return; }
    const newSelection = [...this.selectedValues, item];
    this.valueChange.emit(newSelection);
  }

  removeMapping(item: any) {
    if (this.isUnusedVendor(item?.Key)) {
      return;
    }
    const newSelection = this.selectedValues.filter(v => v.Key !== item.Key);
    this.valueChange.emit(newSelection);
  }

  removeAll() {
    this.valueChange.emit([]);
  }

  isUnusedVendor(itemKey: string): boolean {
    if (!this.activeVendorNames || this.activeVendorNames.size === 0 || !itemKey) {
      return false;
    }

    const normalizedKey = this.normalizeSourceKeyUtils(itemKey);
    return !this.activeVendorNames.has(normalizedKey);
  }

  getFieldName(itemKey: string): string {
    if (!itemKey) {
      return '';
    }

    return itemKey.split('.').slice(1).join('.') || itemKey;
  }

  private normalizeSourceKeyUtils = (itemKey: string): string => {
    if (!itemKey) { return ''; }
    const vendorName = itemKey.split('.')[0] || '';
    return vendorName.replace(/\s+/g, '').toLowerCase();
  }

}
